import GroupWorkspace from './GroupWorkspace';
export default GroupWorkspace;